import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Button from "@mui/material/Button";
import { useDispatch, useSelector } from "react-redux";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import {
  InputLabel,
  MenuItem,
  FormControl,
  Select,
  TextField,
  Autocomplete,
} from "@mui/material";
import "./ApplicantDocuments.css";

import {
  GetUserId,
  getUserDetails,
  GetUserInfo,
} from "../../../_utilities/getUserInfo";
import { updateSnackbar } from "../../../_redux/SnackbarSlice";
import * as _ser from "../../../_redux/_services/ApplicantsSlice";
import { decrypt } from "../../../_utilities/_encryptDecryptHelper";
import { AddDocumentsillus } from "../../../Icons/AddDocumentsillus";
import RightSideBar from "../../../components/Rightsidebar/RightSideBar";
import { defaultApplicantsData } from "../../../_utilities/defaultfieldsModel";
import { customFieldsAsync } from "../../../_redux/_services/UserManagerSlice";
import DocumentViewer from "../../../components/DocumentViewer/DocumentViewer";

import { Document, Page, pdfjs } from "react-pdf";
import DocViewer, { DocViewerRenderers } from "@cyntler/react-doc-viewer";

import "react-pdf/dist/Page/TextLayer.css";
import "react-pdf/dist/Page/AnnotationLayer.css";
import * as pdfjsLib from "pdfjs-dist";
import KeywordHighlighter from "../../../components/KeywordHighlighter/KeywordHighlighter";
import {
  MAX_FILE_SIZE_MB,
  MAX_FILE_SIZE_BYTES,
} from "../../../_utilities/constants";
// import workerSrc from "pdfjs-dist/build/pdf.worker.min.mjs?url"; // bundler emits a valid URL
// import pdfjsWorker from "pdfjs-dist/build/pdf.worker.entry";
// import pdfjsWorker from "react-pdf/node_modules/pdfjs-dist/build/pdf.worker.entry";

const initalState = { data: null, message: "", isloader: true };

// pdfjs.GlobalWorkerOptions.workerSrc = new URL(
//   'pdfjs-dist/build/pdf.worker.min.mjs',
//   import.meta.url,
// ).toString();

pdfjsLib.GlobalWorkerOptions.workerSrc =
  process.env.PUBLIC_URL + "/pdf.worker.min.mjs";

// 👇 creates an absolute same-origin URL to the worker file
// const workerSrc = new URL(
//   "pdfjs-dist/build/pdf.worker.min.mjs",
//   import.meta.url
// ).toString();

// if (typeof window !== "undefined") {
//   pdfjs.GlobalWorkerOptions.workerSrc = workerSrc;
// }

// pdfjs.GlobalWorkerOptions.workerSrc = pdfjsWorker;

// pdfjs.GlobalWorkerOptions.workerSrc = 'pdf.worker.min.js';
// pdfjs.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@5.4.296/build/pdf.worker.min.mjs`

const AddApplicantDocuments = ({
  HandlerType,
  JobId,
  previewType,
  DocName,
  onReceivePropsHandler,
  fileExtention,
}) => {
  return (
    <div id={HandlerType === "view" ? "documentViewer" : "uploadviewer"}>
      <RightSideBar
        componentData={
          <ComponentRenderData
            JobId={JobId}
            handler={HandlerType}
            previewType={previewType}
            DocName={DocName}
            fileExtention={fileExtention}
            onReceivechildProps={onReceivePropsHandler}
          />
        }
        componentLayout={HandlerType === "view" ? pannelobjview : pannelobj}
        footerImg={
          HandlerType === "view" ? <AddDocumentsillus /> : <AddDocumentsillus />
        }
        onReceiveProps={onReceivePropsHandler}
      />
    </div>
  );
};

const ComponentRenderData = (props) => {
  const [imgList, setImgList] = useState([]);
  const [imgData, setImgData] = useState([]);
  const [isUploaded, setIsUploaded] = useState(true);
  const [disableSubmitBtn, setDisableSubmitBtn] = React.useState(true);
  const [docUrl, setDocUrl] = useState(null);
  const [docType, setDocType] = useState(null);
  const [sourceModelValues, setSourceModelValues] = useState([]);
  const [documentTypeOptions, setDocumentTypeOptions] = useState([]);
  const [sourced, setSourced] = useState(null);
  const [showSourcedfrom, setShowSourcedfrom] = useState(false);
  const [pdfSrc, setPdfSrc] = useState(null);

  const fileType = "jpg not supported";
  const dispatch = useDispatch();

  const UploadDocCode = useSelector((state) => state.UploadDocuments.data);
  const customFieldsData = useSelector((state) => state.CustomFields.data);

  // Removed unused docs + invalid headers
  // const docs = [{ uri: docUrl }]
  // const headers = {
  //   "Access-Control-Allow-Origin": "*",
  //   'Content-Type': 'application/pdf'
  // };
  // keep pdfSrc in sync with docUrl

  useEffect(() => {
    setPdfSrc(docUrl || null);
  }, [docUrl]);

  // fallback: fetch PDF as blob and use a blob: URL
  const loadPdfAsBlob = async () => {
    try {
      if (!docUrl) return;
      const res = await fetch(docUrl, {
        // tweak if your server requires cookies
        credentials: "include", // or 'omit' if not needed
        // headers: { Authorization: Bearer ${token} }, // if you need auth
      });
      if (!res.ok) throw new Error(`HTTP ${res.status}`);
      const blob = await res.blob();
      // Optional: ensure it is a PDF; if not, still try to render
      // if (blob.type !== 'application/pdf') console.warn('MIME:', blob.type);
      const url = URL.createObjectURL(blob);
      setPdfSrc(url);
    } catch (e) {
      console.error("Blob fallback failed:", e);
    }
  };
  useEffect(() => {
    if (props.previewType !== "") {
      setDocUrl(props.previewType);
    }
  }, [props.previewType]);

  useEffect(() => {
    if (imgData.length === 0 && imgList.length === 0) {
      setIsUploaded(true);
    }
  }, [imgData, imgList]);

  const onRemoveItem = (item) => {
    let imgNames = JSON.parse(JSON.stringify(imgList));
    let findIndex = imgNames.findIndex((x) => x.id === item.id);
    if (findIndex !== -1) {
      imgNames.splice(findIndex, 1);
      imgData.splice(findIndex, 1);
      setImgList(imgNames);
    }
    imgData.splice(parseInt(item.id), 1);
    setImgData(imgData);
  };

  const fileImgHandler = (event) => {
    let files = event.target.files;
    let imgNames = JSON.parse(JSON.stringify(imgList));
    let imgObj = JSON.parse(JSON.stringify(imgData));
    var fileInput = document.getElementById("fileId");
    let extension = files[0].name.substring(files[0].name.lastIndexOf("."));
    var filePath = fileInput.value || extension;
    var allowedExtensions = /(\.doc|\.docx|\.pdf)$/i;
    if (!allowedExtensions.exec(filePath)) {
      dispatch(
        updateSnackbar({
          type: "error",
          message:
            "Invalid file format. Please upload a Doc, Pdf, or Docx file",
        }),
      );
      fileInput.value = "";
      return false;
    } else {
      let tempImgNames = [],
        tempImgObj = [];
      for (var i = 0; i < files.length; i++) {
        if (files[i].size > MAX_FILE_SIZE_BYTES) {
          dispatch(
            updateSnackbar({
              type: "error",
              message: `File size exceeds ${MAX_FILE_SIZE_MB}MB. Please upload a smaller file.`,
            }),
          );
          continue;
        }
        let obj = { id: Date.now() + i, name: files[i].name };
        tempImgNames.push(obj);
        tempImgObj.push(files[i]);
      }
      imgNames.push(...tempImgNames);
      imgObj.push(...tempImgObj);
      setImgList(imgNames);
      setIsUploaded(false);
      setImgData(imgObj);
    }
    event.target.value = "";
  };

  const uploadDocuments = async () => {
    if (
      docType === "Resume"
        ? docType && sourced && imgList.length !== 0
        : docType && imgList.length !== 0
    ) {
      setDisableSubmitBtn(true);
      // let userData = await GetUserInfo();

      const userInfo = await getUserDetails();

      let formData = new FormData();
      let checkFileType = imgData.filter(
        (elem) =>
          elem.name.match(/jpg/) ||
          elem.name.match(/png/) ||
          elem.name.match(/jpeg/) ||
          elem.name.match(/JPEG/) ||
          elem.name.match(/SVG/) ||
          elem.name.match(/gif/),
      );
      if (checkFileType.length > 0) {
        alert("file does not support");
      } else {
        for (let i = 0; i < imgData.length; i++) {
          formData.append("Resume", imgData[i]);
        }
        formData.append("id", props.JobId);
        formData.append("userId", userInfo.userId);
        formData.append("DbUserId", userInfo.id);
        formData.append("ResumeUserId", userInfo.id);
        formData.append("fileType", docType);
        formData.append("resumesourceId", sourced?.id ? sourced.id : "");
        formData.append("resumesource", sourced?.name ? sourced.name : "");
        formData.append("userFirstName", userInfo.firstName);
        formData.append("userLastName", userInfo.lastName);
        dispatch(_ser.uploadDocumentsAsync(props.JobId, formData, true))
          .then(() => {
            setDisableSubmitBtn(false);
          })
          .catch(() => {
            setDisableSubmitBtn(false);
          });
      }
    } else {
      dispatch(
        updateSnackbar({ type: "error", message: "All fields are required" }),
      );
    }
  };

  useEffect(() => {
    if (UploadDocCode === 200 || UploadDocCode === 208) {
      dispatch(_ser.uploadDocumentsStartReducer(initalState));
      props.onReceivechildProps(false, true, null);
    }
  }, [UploadDocCode]);

  const downloadHandler = () => {
    // props.onReceivechildProps({ path: props.DocName }, "download", "");
    props.onReceivechildProps(
      { path: props.DocName, fileType: props.fileExtention },
      "",
      "download",
    );
  };

  const onChangeHandler = (e, type) => {
    if (type === "choosedocument") {
      setDocType(e.target.value);
    } else if (type === "Sourced From") {
      let obj = {
        id: e.target.value,
        name: sourceModelValues[parseInt(e.target.value) - 1],
      };
      setSourced(obj);
    }
  };

  useEffect(() => {
    if (docType === "Resume") {
      setShowSourcedfrom(true);
    } else {
      setShowSourcedfrom(false);
      setSourced(null);
    }
    if (
      docType === "Resume"
        ? docType && sourced && imgList.length !== 0
        : docType && imgList.length !== 0
    ) {
      setDisableSubmitBtn(false);
    } else {
      setDisableSubmitBtn(true);
    }
  }, [docType, sourced, imgList]);

  useEffect(() => {
    async function init() {
      let userId = await GetUserId();
      dispatch(customFieldsAsync(userId));
    }
    init();
  }, []);

  const [numPages, setNumPages] = useState(0);
  const onDocumentLoadSuccess = ({ numPages }) => {
    setNumPages(numPages);
  };

  useEffect(() => {
    if (customFieldsData && customFieldsData.length > 0) {
      const data = JSON.parse(JSON.stringify(customFieldsData));
      let overrideDefaultPostingFieldsData = data.filter(
        (x) => x.moduleId.toString() === "2" && x.fieldType === "default",
      );
      if (overrideDefaultPostingFieldsData.length > 0) {
        overrideDefaultPostingFieldsData.forEach((list) => {
          if (list.fieldName === "Source") {
            let updatedCustomValues = JSON.parse(list.customValues);
            let modifiedCustomValues = [];
            updatedCustomValues.forEach((list) => {
              if (
                list !== "Cloud Sourcing" &&
                list !== "Employee Portal" &&
                list !== "Vendor Sourcing" &&
                list !== "Job Board Portal"
              ) {
                modifiedCustomValues.push(list);
              }
            });
            setSourceModelValues(modifiedCustomValues);
          } else if (list.fieldName === "Document type") {
            let documentTypeOptions = JSON.parse(list.customValues);
            documentTypeOptions.push("Other");
            setDocumentTypeOptions(documentTypeOptions);
          }
        });
      }
      // dispatch(customFieldsStartReducer({}));
    }
  }, [customFieldsData]);

  useEffect(() => {
    let defaultPostingModules = defaultApplicantsData.filter(
      (x) => x.moduleId.toString() === "2",
    );
    if (defaultPostingModules.length > 0) {
      defaultPostingModules.forEach((list) => {
        if (list.fieldName === "Source") {
          setSourceModelValues(list.customValues);
        }
      });
    }
  }, []);
  if (props.handler === "New document") {
    return (
      <>
        <div className="choosedocument">
          <FormControl fullWidth autoComplete="off" variant="outlined">
            <InputLabel className="boldSelectlabel" shrink={true}>
              Choose Document*
            </InputLabel>

            <Autocomplete
              fullWidth
              options={documentTypeOptions}
              value={docType}
              onChange={(event, newValue) => {
                setDocType(newValue);
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  variant="outlined"
                  className="boldSelectlabel"
                />
              )}
              getOptionLabel={(option) => option || ""}
              className="choosedocumentinput"
            />
          </FormControl>

          {showSourcedfrom && (
            <FormControl
              fullWidth
              autoComplete="off"
              variant="outlined"
              style={{ marginTop: "35px" }}
            >
              <InputLabel className="boldSelectlabel" shrink={true}>
                Sourced from *
              </InputLabel>
              <Autocomplete
                fullWidth
                options={sourceModelValues}
                value={sourced ? sourced.name : null}
                onChange={(event, newValue) => {
                  if (newValue) {
                    const index = sourceModelValues.indexOf(newValue);
                    setSourced({ id: (index + 1).toString(), name: newValue });
                  } else {
                    setSourced(null);
                  }
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    variant="outlined"
                    className="boldSelectlabel"
                  />
                )}
                getOptionLabel={(option) => option || ""}
                className="sourcedfrominput"
              />
            </FormControl>
          )}
        </div>
        {isUploaded ? (
          <>
            <div className="uploadfileicon">
              <img
                src={process.env.PUBLIC_URL + "/assests/img/uploadBgIcon.svg"}
                alt=""
              />
            </div>
            <Button
              variant="contained"
              component="label"
              className="appuploadresume"
              disabled={imgList.length > 0}
            >
              <span>
                <b style={{ color: "var(--primary-bg-color)" }}>Upload</b>
                <b style={{ color: "#9E9E9E" }}> browse file to upload </b>
              </span>
              <input
                hidden
                // ✅ limit to supported types only
                accept=".pdf,.doc,.docx,application/pdf,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                type="file"
                id="fileId"
                onChange={(e) => fileImgHandler(e)}
              />
            </Button>
            <p className="docsupporttext">
              Supported file formats: Doc, Pdf, Docx{" "}
            </p>
          </>
        ) : (
          ""
        )}
        {imgList.length > 0 ? (
          <ul className="listofUploads">
            {imgList &&
              imgList.map((list) => {
                return (
                  <li key={list.id}>
                    <p>{list.name}</p>
                    <p>
                      {list.name.match(".jpg") ||
                      list.name.match(".png") ||
                      list.name.match(/jpg/) ||
                      list.name.match(/png/) ||
                      list.name.match(/jpeg/) ||
                      list.name.match(/JPEG/) ||
                      list.name.match(/SVG/)
                        ? fileType
                        : ""}
                    </p>
                    <span
                      className="closeImgbtn"
                      onClick={() => onRemoveItem(list)}
                    >
                      <DeleteOutlineIcon />
                    </span>
                  </li>
                );
              })}
          </ul>
        ) : (
          ""
        )}
        <div className="actionBtns">
          <Button
            type="button"
            className="cancelBtn"
            size="small"
            onClick={() => {
              props.onReceivechildProps(false, false, null);
            }}
          >
            <Link
              href="#"
              style={{ color: "red", fontSize: "14px" }}
              underline="always"
            >
              {" "}
              Cancel
            </Link>
          </Button>
          <Button
            type="button"
            variant="contained"
            className="saveBtn"
            onClick={uploadDocuments}
            size="small"
          >
            Save
          </Button>
        </div>
      </>
    );
  } else if (props.handler === "view") {
    const ext = (props.fileExtention || "").toLowerCase();
    return (
      // <DocumentViewer
      //   url={props.previewType}
      //   fileType={ext}
      //   onDownload={() => {
      //     props.onReceivechildProps(
      //       { path: props.DocName, fileType: props.fileExtention },
      //       '',
      //       'download'
      //     );
      //     // console.log("⬇️ Download button clicked:", props.DocName, props.fileExtention);
      //   }}
      // />
      <div className="applicant-list-documentviewer custom-align-documentviewer">
        <KeywordHighlighter file={props.previewType} />
      </div>
    );
  }
};
export default AddApplicantDocuments;

const pannelobj = {
  title: "Add documents",
  description: "Select Document Type",
  bgImage: "",
};

const pannelobjview = {
  title: "Document view",
  description: "",
  bgImage: "",
};

// import React, { useEffect, useState } from "react";

// import { Link } from "react-router-dom";
// import Button from "@mui/material/Button";
// import { DocumentViewer } from 'react-documents';
// import { useDispatch, useSelector } from "react-redux";
// import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
// import { InputLabel, MenuItem, FormControl, Select } from '@material-ui/core';

// import { GetUserId, getUserDetails, GetUserInfo } from '../../../_utilities/getUserInfo';
// import { updateSnackbar } from '../../../_redux/SnackbarSlice';
// import * as _ser from '../../../_redux/_services/ApplicantsSlice';
// import { decrypt } from "../../../_utilities/_encryptDecryptHelper";
// import { AddDocumentsillus } from "../../../Icons/AddDocumentsillus";
// import RightSideBar from "../../../components/Rightsidebar/RightSideBar";
// import { defaultApplicantsData } from '../../../_utilities/defaultfieldsModel';
// import { customFieldsAsync, customFieldsStartReducer } from '../../../_redux/_services/UserManagerSlice';
// import { Document, Page, pdfjs } from 'react-pdf'; // For PDF viewing

// import DocViewer, { DocViewerRenderers } from '@cyntler/react-doc-viewer'; // For DOC viewing
// import workerSrc from "pdfjs-dist/build/pdf.worker.min.mjs?url";

// import "./ApplicantDocuments.css";

// const initalState = { data: null, message: '', isloader: true }
// // pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;
// pdfjs.GlobalWorkerOptions.workerSrc = `${process.env.PUBLIC_URL}/pdf.worker.min.mjs`;

// // pdfjs.GlobalWorkerOptions.workerSrc = new URL(
// //   "pdfjs-dist/build/pdf.worker.min.js",
// //   import.meta.url
// // ).toString();
// // pdfjs.GlobalWorkerOptions.workerSrc = workerSrc;
// const AddApplicantDocuments = ({
//   HandlerType,
//   JobId,
//   previewType,
//   DocName,
//   onReceivePropsHandler,
//   fileExtention
// }) => {

//   return (
//     <div id={HandlerType === "view" ? "documentViewer" : 'uploadviewer'}>
//       <RightSideBar
//         componentData={
//           <ComponentRenderData
//             JobId={JobId}
//             handler={HandlerType}
//             previewType={previewType}
//             DocName={DocName}
//             fileExtention={fileExtention}
//             onReceivechildProps={onReceivePropsHandler}
//           />
//         }
//         componentLayout={HandlerType === "view" ? pannelobjview : pannelobj}
//         footerImg={HandlerType === "view" ? <AddDocumentsillus /> : <AddDocumentsillus />}
//         onReceiveProps={onReceivePropsHandler}
//       />
//     </div>
//   );
// };

// const ComponentRenderData = (props) => {
//   const [imgList, setImgList] = useState([]);
//   const [imgData, setImgData] = useState([]);
//   const [isUploaded, setIsUploaded] = useState(true);
//   const [disableSubmitBtn, setDisableSubmitBtn] = React.useState(true);
//   const [docUrl, setDocUrl] = useState(null);
//   const [docType, setDocType] = useState(null);
//   const [sourceModelValues, setSourceModelValues] = useState([]);
//   const [sourced, setSourced] = useState(null);
//   const [showSourcedfrom, setShowSourcedfrom] = useState(false);

//   const fileType = "jpg not supported";
//   const dispatch = useDispatch();

//   const UploadDocCode = useSelector(state => state.UploadDocuments.data);
//   const customFieldsData = useSelector(state => state.CustomFields.data);
// const docs = [
//   {
//     uri: docUrl
//   }
// ]

// const headers = {
//   "Access-Control-Allow-Origin": "*",
//   'Content-Type': 'application/pdf'
// };

//   useEffect(() => {
//     if (props.previewType !== "") {
//       setDocUrl(props.previewType)
//       console.log("props.previewType", props.previewType);
//     }
//   }, [props]);

//   useEffect(() => {
//     if (imgData.length === 0 && imgList.length === 0) {
//       setIsUploaded(true);
//     }
//   }, [imgData, imgList]);

//   const onRemoveItem = (item) => {
//     let imgNames = JSON.parse(JSON.stringify(imgList));
//     let findIndex = imgNames.findIndex((x) => x.id === item.id);
//     if (findIndex !== -1) {
//       imgNames.splice(findIndex, 1);
//       imgData.splice(findIndex, 1);
//       setImgList(imgNames);
//     }
//     imgData.splice(parseInt(item.id), 1);
//     setImgData(imgData);
//   };

//   const fileImgHandler = (event) => {
//     let files = event.target.files;
//     let imgNames = JSON.parse(JSON.stringify(imgList));
//     let imgObj = JSON.parse(JSON.stringify(imgData));
//     var fileInput = document.getElementById('fileId');
//     let extension = files[0].name.substring(files[0].name.lastIndexOf('.'));
//     var filePath = fileInput.value || extension;
//     var allowedExtensions = /(\.doc|\.docx|\.pdf)$/i;
//     if (!allowedExtensions.exec(filePath)) {
//       dispatch(updateSnackbar({ type: 'error', message: "Invalid file format. Please upload a Doc, Pdf, or Docx file" }));
//       fileInput.value = '';
//       return false;
//     }
//     else {
//       let tempImgNames = [],
//         tempImgObj = [];
//       for (var i = 0; i < files.length; i++) {
//         let obj = { id: i, name: files[i].name };
//         tempImgNames.push(obj);
//         tempImgObj.push(files[i]);
//       }
//       imgNames.push(...tempImgNames);
//       imgObj.push(...tempImgObj);
//       setImgList(imgNames);
//       setIsUploaded(false);
//       setImgData(imgObj);
//     }
//     event.target.value = '';
//   };

//   useEffect(() => {
//     console.log("imgList", imgList);
//   }, [imgList]);

//   useEffect(() => {
//     console.log("imgData", imgData);
//   }, [imgData]);

//   const uploadDocuments = async () => {
//     if (docType === "Resume" ? (docType && sourced && imgList.length !== 0) : (docType && imgList.length !== 0)) {

//       setDisableSubmitBtn(true)
//       let userData = GetUserInfo();
//       console.log(userData[0].userId);

//       const userInfo = await getUserDetails();
//       let formData = new FormData();
//       let checkFileType = imgData.filter((elem) => elem.name.match(/jpg/) || elem.name.match(/png/) || elem.name.match(/jpeg/) || elem.name.match(/JPEG/) || elem.name.match(/SVG/) || elem.name.match(/gif/));
//       if (checkFileType.length > 0) {
//         alert("file does not support");
//       } else {
//         for (let i = 0; i < imgData.length; i++) {
//           formData.append("Resume", imgData[i]);
//         }
//         formData.append("id", props.JobId);
//         formData.append("userId", userInfo.userId);
//         formData.append("DbUserId", userData[0].userId);
//         formData.append("ResumeUserId", userData[0].userId);
//         formData.append("fileType", docType);
//         formData.append("resumesourceId", sourced?.id ? sourced.id : "");
//         formData.append("resumesource", sourced?.name ? sourced.name : "");
//         formData.append("userFirstName", userInfo.firstName);
//         formData.append("userLastName", userInfo.lastName);
//         dispatch(_ser.uploadDocumentsAsync(props.JobId, formData, true)).then(() => {
//           setDisableSubmitBtn(false)
//         }).catch(() => {
//           setDisableSubmitBtn(false)
//         });
//       }
//     } else {
//       dispatch(updateSnackbar({ type: 'error', message: "All fields are required" }));
//     }
//   };

//   useEffect(() => {
//     if (UploadDocCode === 200 || UploadDocCode === 208) {
//       dispatch(_ser.uploadDocumentsStartReducer(initalState))
//       props.onReceivechildProps(false, true, null);
//     }
//   }, [UploadDocCode])

//   const downloadHandler = () => {
//     props.onReceivechildProps({ path: props.DocName }, "Download", "");
//   }

//   const onChangeHandler = (e, type) => {
//     if (type === "choosedocument") {
//       setDocType(e.target.value)
//     } else if (type === "Sourced From") {
//       let obj = { id: e.target.value, name: sourceModelValues[(parseInt(e.target.value) - 1)] };
//       setSourced(obj)
//     }
//   }

//   useEffect(() => {
//     if (docType === "Resume") {
//       setShowSourcedfrom(true);
//     } else {
//       setShowSourcedfrom(false);
//       setSourced(null);
//     }
//     if (docType === "Resume" ? (docType && sourced && imgList.length !== 0) : (docType && imgList.length !== 0)) {
//       setDisableSubmitBtn(false);
//     } else {
//       setDisableSubmitBtn(true);
//     }
//   }, [docType, sourced, imgList])

//   useEffect(() => {
//     let userId = GetUserId()
//     dispatch(customFieldsAsync(userId));
//   }, [])

//     const [numPages, setNumPages] = useState(null);

//   const onDocumentLoadSuccess = ({ numPages }) => {
//     setNumPages(numPages);
//   };

//   useEffect(() => {
//     if (customFieldsData && customFieldsData.length > 0) {
//       const data = JSON.parse(JSON.stringify(customFieldsData));
//       let overrideDefaultPostingFieldsData = data.filter(x => x.moduleId.toString() === "2" && x.fieldType === "default");
//       if (overrideDefaultPostingFieldsData.length > 0) {
//         overrideDefaultPostingFieldsData.forEach(list => {
//           if (list.fieldName === "Source") {
//             let updatedCustomValues = JSON.parse(list.customValues);
//             let modifiedCustomValues = [];
//             updatedCustomValues.forEach(list => {
//               if (list !== "Cloud Sourcing" && list !== "Employee Portal" && list !== "Vendor Sourcing" && list !== "Job Board Portal") {
//                 modifiedCustomValues.push(list);
//               }
//             })
//             setSourceModelValues(modifiedCustomValues);
//           }
//         })
//       }
//       dispatch(customFieldsStartReducer({}));
//     }
//   }, [customFieldsData])

//   useEffect(() => {
//     let defaultPostingModules = defaultApplicantsData.filter(x => x.moduleId.toString() === "2");
//     if (defaultPostingModules.length > 0) {
//       defaultPostingModules.forEach(list => {
//         if (list.fieldName === "Source") {
//           setSourceModelValues(list.customValues);
//         }
//       })
//     }
//   }, [])

//   if (props.handler === "New document") {
//     return (
//       <>
//         <div className="choosedocument">
//           <FormControl
//             fullWidth
//             autoComplete="off"
//             variant="outlined"
//           >
//             <InputLabel className="boldSelectlabel" shrink={true} >Choose Document*</InputLabel>
//             <Select
//               value={docType}
//               name="choosedocument"
//               autoComplete="off"
//               label="Choose Document* &nbsp;"
//               onChange={(e) => onChangeHandler(e, "choosedocument")}
//               className="choosedocumentinput"
//             >
//               <MenuItem className="selectOptions" value="Resume">Resume</MenuItem>
//               <MenuItem className="selectOptions" value="Cover letter">Cover letter</MenuItem>
//               <MenuItem className="selectOptions" value="ID Proof">ID Proof</MenuItem>
//               <MenuItem className="selectOptions" value="Other">Other</MenuItem>
//             </Select>
//           </FormControl>

//           {showSourcedfrom &&
//             <FormControl
//               fullWidth
//               autoComplete="off"
//               variant="outlined"
//               style={{ marginTop: "35px" }}
//             >
//               <InputLabel className="boldSelectlabel" shrink={true} >Sourced from *</InputLabel>
//               <Select
//                 value={sourced?.id}
//                 name="Sourced From"
//                 autoComplete="off"
//                 label="Sourced From*&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"
//                 onChange={(e) => onChangeHandler(e, "Sourced From")}
//                 className="sourcedfrominput"
//                 MenuProps={{
//                   PaperProps: {
//                     style: {
//                       marginTop: 55, // Adjust this value to overlap the input
//                       zIndex: 1300, // Ensure it's above other elements
//                     },
//                   },
//                 }}
//               >
//                 {sourceModelValues.map((name, index) => (
//                   <MenuItem className="selectOptions" key={name} value={(index + 1).toString()}>
//                     {name}
//                   </MenuItem>
//                 ))}
//               </Select>
//             </FormControl>
//           }
//         </div>
//         {isUploaded ? (
//           <>
//             <div className='uploadfileicon'>
//               <img src={process.env.PUBLIC_URL + "/assests/img/uploadBgIcon.svg"} alt="" />
//             </div>
//             <Button
//               variant="contained"
//               component="label"
//               className="appuploadresume"
//               disabled={imgList.length > 0}
//             >
//               <span>
//                 <b style={{ color: "var(--primary-bg-color)" }}>Upload</b>
//                 <b style={{ color: "#9E9E9E" }}> browse file to upload </b></span>
//               <input
//                 hidden
//                 accept="file/*"
//                 type="file"
//                 id="fileId"
//                 onChange={(e) => fileImgHandler(e)} />
//             </Button>
//             <p className="docsupporttext">Supported file formats: Doc, Pdf, Docx </p>
//           </>
//         ) : ("")}
//         {imgList.length > 0 ? (
//           <ul className="listofUploads">
//             {imgList &&
//               imgList.map((list) => {
//                 return (
//                   <li key={list.id}>
//                     <p>{list.name}</p>
//                     <p>{list.name.match(".jpg") || list.name.match(".png") ||
//                       list.name.match(/jpg/) || list.name.match(/png/) || list.name.match(/jpeg/) ||
//                       list.name.match(/JPEG/) || list.name.match(/SVG/)
//                       ? fileType : ""}</p>
//                     <span
//                       className="closeImgbtn"
//                       onClick={() => onRemoveItem(list)}
//                     >
//                       <DeleteOutlineIcon />
//                     </span>
//                   </li>
//                 );
//               })}
//           </ul>
//         ) : (
//           ""
//         )}
//         <div className="actionBtns">
//           <Button
//             type="button"
//             className="cancelBtn"
//             size="small"
//             onClick={() => {
//               props.onReceivechildProps(false, false, null);
//             }}
//           >
//             <Link href="#" style={{ color: "red", fontSize: "14px" }} underline="always"> Cancel</Link>
//           </Button>
//           <Button
//             type="button"
//             variant="contained"
//             className="saveBtn"
//             onClick={uploadDocuments}
//             size="small"
//           >
//             Save
//           </Button>
//         </div>
//       </>
//     );
//   } else if (props.handler === "view") {
//     return (
//       <>
//         <div style={{ textAlign: "center" }}>
//           {docUrl !== null ?
//             <>
//               {/* <DocumentViewer
//                 url={docUrl}
//                 style={{ width: "100%", height: "calc(100vh - 120px)" }}
//               >
//               </DocumentViewer> */}
//               {props.fileExtention !== 'pdf' ? (

//       <div>
//         <Document
//           file={docUrl}
//           onLoadSuccess={onDocumentLoadSuccess}
//           loading="Loading PDF..."
//         >
//          {Array.from({ length: numPages || 0 }, (_, i) => (
//                 <Page key={`page_${i + 1}`} pageNumber={i + 1} />
//               ))}
//         </Document>
//       </div>
//   ):(props.fileExtention === 'doc' || props.fileExtention === 'docx' || props.fileExtention === 'pdf') ? (
//       <DocViewer
//         pluginRenderers={DocViewerRenderers}
//         // documents={ docs }
//          documents={[{ uri: docUrl, fileType: props.fileExtention }]}
//         prefetchMethod="GET"
//         requestHeaders={headers}
//         config={{
//           header: { disableHeader: true, disableFileName: false },
//           pdfZoom: { scale: 1.0 },
//         }}
//       />
//  ) : (
//     <div>Unsupported file format</div>
//   )
// }
//               <div className="floatBtn" onClick={downloadHandler}>
//                 <svg id="a852fdaa-156c-46c0-a3b6-364630b4c7fc" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 637.22 637.22">
//                   <g>
//                     <circle cx="318.61" cy="318.61" r="318.61" style={{ fill: "#404040" }} />
//                     <g>
//                       <path d="M363.11,176.87c0,19.08,0,38.16,0,57.24.05,22.81,16.39,39.29,39.21,39.45,16.08.12,32.15,0,48.23,0h4.55v74.13c-4.44,0-8.83-.12-13.22,0C414.6,348.65,390.4,358,369.14,375a15.67,15.67,0,0,1-10.62,3.64c-34.63-.15-69.26-.08-103.89-.08h-2.75c-6.49,0-10.1,2.62-10.11,7.28s3.6,7.29,10.1,7.29q46.85,0,93.7,0h4.81c-1.05,1.64-1.77,2.67-2.4,3.75-4.75,8.23-9.63,16.4-14.14,24.76-1.23,2.29-2.35,3.15-5,3.14-24.7-.11-49.4-.07-74.1-.07h-3.53c-5.92,0-9.33,2.59-9.45,7.09s3.36,7.35,9.54,7.38c9.15,0,18.29,0,27.44,0h48.67c-6.34,27.06-4.53,53.06,5.91,78.74H226.65c-11.18,0-20.73-3.61-27.76-12.68-4.94-6.37-6.73-13.71-6.73-21.63q0-55.68,0-111.34,0-80.37,0-160.75c0-14,5.62-24.78,18.32-31.26,3.07-1.57,6.59-2.27,9.91-3.37Zm-68.61,171q21.74,0,43.48,0a18.39,18.39,0,0,0,4.27-.34,6.94,6.94,0,0,0,5.4-7.19,6.76,6.76,0,0,0-6-6.64,26.72,26.72,0,0,0-4.29-.26h-85a29.08,29.08,0,0,0-4.67.3A6.49,6.49,0,0,0,242.1,339c-1.2,4.9,2.27,8.79,8.13,8.81C265,347.86,279.74,347.82,294.5,347.82Z" transform="translate(-43.92 -47.78)" style={{ fill: "#fff" }} />
//                       <path d="M438.39,578.35c-6-1.08-12.13-1.8-18-3.3-44.26-11.19-76.92-48.47-81.52-92.81-5.67-54.73,28.63-103.38,82.56-117.09,39.89-10.14,85.49,6.15,110.29,39.15,17.35,23.07,25.37,49,21.79,77.52-5.32,42.52-28.34,72.51-68,88.79-9.86,4-20.88,5.24-31.36,7.74Zm16.36-65.57-1.36-.9v-4.12q0-47.22,0-94.46a33.32,33.32,0,0,0-.17-4.69,7.08,7.08,0,0,0-14-.23,28.14,28.14,0,0,0-.21,4.69q0,47.42,0,94.85v4l-1.16.55a36,36,0,0,0-2.33-3.11q-17.49-18.79-35-37.54a19.07,19.07,0,0,0-3.46-3.15A7.07,7.07,0,0,0,387,478.15a18.15,18.15,0,0,0,2.4,3.07q24.68,26.56,49.38,53.1c5.41,5.8,9,5.8,14.36,0q24.47-26.22,48.91-52.46a19.6,19.6,0,0,0,3.13-4c1.63-3.1,1.26-6.17-1.4-8.54a6.63,6.63,0,0,0-8.64-.63,19.83,19.83,0,0,0-3.43,3.18q-17.5,18.78-35,37.62A19.83,19.83,0,0,0,454.75,512.78Z" transform="translate(-43.92 -47.78)" style={{ fill: "#fff" }} />
//                       <path d="M445.4,259.17c-15.7,0-30.2.26-44.68-.08-13.26-.32-22.61-9.85-23.05-23.82-.47-15.13-.09-30.29-.07-45.45,0-.22.19-.45.59-1.32Z" transform="translate(-43.92 -47.78)" style={{ fill: "#fff" }} />
//                     </g>
//                   </g>
//                 </svg>
//               </div>
//             </>
//             : ""}
//         </div>
//       </>
//     )
//   }
// };
// export default AddApplicantDocuments;

// const pannelobj = {
//   title: "Add documents",
//   description: "Select Document Type",
//   bgImage: "",
// };

// const pannelobjview = {
//   title: "Document view",
//   description: "",
//   bgImage: "",
// };
